enum SortType {
  SortOrder = 'SortOrder',
  SortOrderInput = 'SortOrderInput',
}

export default SortType;
